/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/self-closing-comp */
import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from '@reach/router';
import env from '@/env';
import { getWebAppInfo } from '@/utils';
// import logo192 from '@/assets/images/logo192.png';
import coverImage from '@/assets/images/cover.png';

interface HelmetHeadProps {
  title: string;
  description: string;
  image?: string;
  renderLargeShiftLayout?: boolean;
}

const HelmetHead: React.FC<HelmetHeadProps> = ({ title, description, image, renderLargeShiftLayout }) => {
  const webApp = getWebAppInfo(env.siteId);

  const { pathname } = useLocation();

  return (
    <Helmet>
      {/* Fix "Mixed Content" in google test
      {process.env.NODE_ENV !== 'development' && <base href={env.rootUrl} />} */}
      <meta charSet="utf-8" />
      <link rel="icon" href={webApp.metadata.favicon} />
      <link rel="canonical" href={`${env.rootUrl}${pathname}`} />

      <title>{title}</title>
      <meta name="description" content={description} />
      <meta
        name="keywords"
        content={`${webApp.siteName}, Open Banking, APIs, Open Banking APIs, Payment APIs, Lending APIs, KYC APIs, PSD2, CMA, AISP, PISP, Banking Regulations, GDPR, PSD2 Compliance, Africa, Asia, Oceania, Middle East, Europe, North America, South America`}
      />

      {/* <!-- Twitter Card data --> */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={webApp.metadata.site} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {/* <-- Twitter Summary card images must be at least 120x120px --> */}
      <meta name="twitter:image" content={image || `https://www.${webApp.domain}${coverImage}`} />
      <meta property="fb:pages" content="101075744945572" />
      <meta property="fb:app_id" content={env.facebookID} />

      {/* <!-- Open Graph data --> */}
      <meta property="og:title" content={title} />
      <meta property="og:type" content="article" />
      <meta property="og:url" content={`${env.rootUrl}${pathname}`} />
      <meta property="og:image" content={image || `https://www.${webApp.domain}${coverImage}`} />
      <meta property="og:image:secure" content={image || `https://www.${webApp.domain}${coverImage}`} />
      <meta property="og:image:secure_url" content={image || `https://www.${webApp.domain}${coverImage}`} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="650" />
      <meta property="og:description" content={description} />
      <meta property="og:site_name" content={env.siteName} />

      {/* <script
        nonce={env.nonceValue}
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${env.ga.adsTrackingCode}`}
      /> */}
      {/* <script nonce="8cQWMsPL0s4CPs5gycOg" async src={`https://www.googletagmanager.com/gtag/js`} /> */}
      {/* <script nonce="8cQWMsPL0s4CPs5gycOg">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
        `}
      </script> */}

      {/* <script nonce={env.nonceValue}>
        {`
          gtag('event', 'conversion', {'send_to': '${env.ga.adsTrackingCode}/2kAKCOOg4PUBEO7MqccB'});
        `}
      </script> */}
      {env.siteId === 'openbankingdirectory' && env?.zendesk?.key && renderLargeShiftLayout && (
        <script
          defer
          nonce={env.nonceValue}
          id="ze-snippet"
          src={`https://static.zdassets.com/ekr/snippet.js?key=${env.zendesk.key}`}
        />
      )}

      {renderLargeShiftLayout && (
        <script
          defer
          nonce={env.nonceValue}
          id={webApp.gdpr.id}
          src={webApp.gdpr.src}
          data-cbid={webApp.gdpr.dataCbid}
          data-blockingmode="auto"
          type="text/javascript"
        ></script>
      )}
      {renderLargeShiftLayout && (
        <script nonce={env.nonceValue} type="application/ld+json" id="webSiteSchema">
          {`{
            "@context": "http://schema.org",
            "@type": "WebSite",
            "name": "${webApp.domainName}${webApp.tld}",
            "url": "https://${webApp.domainName}${webApp.tld}"
          }`}
        </script>
      )}
      {renderLargeShiftLayout && (
        <script nonce={env.nonceValue} type="application/ld+json" id="orgSchema">
          {`{
        "@context": "http://schema.org",
        "@type": "Organization",
        "url": "https://${webApp.domainName}${webApp.tld}",
        "logo": "https://${webApp.domainName}${webApp.tld}/${webApp.logoPath}",
        "sameAs": [
            "${webApp.social.facebook}",
            "${webApp.social.linkedIn}",
            "${webApp.social.twitter}"
        ]
      }`}
        </script>
      )}
    </Helmet>
  );
};

export default HelmetHead;
